class WidgetBase {
	constructor(config, value, index) {
		this.config = config;
		this.index = index;

		if (value !== null) {
			this.value = value[index];
		}
	}

	publish() {	}

	setVal(val) {
		this.el.val(val);
	}

	val() {
		return this.el.val();
	}
}

class TextWidget extends WidgetBase {
	getElement() {
		this.el = $('<input class="form-control" type="text"></input>');

		if (this.value) {
			this.el.val(this.value);
		}

		return this.el;
	}
}

class LinkWidget extends WidgetBase {
	getElement() {
		this.el = $('<a type="text"></a>');

		if (this.value) {
			this.el.text(gettext("Link"));
			this.el.attr("href", this.value);
		}

		return this.el;
	}
}

class HiddenWidget extends WidgetBase {
	getElement() {
		this.el = $('<input type="hidden"></input>');

		if (this.value) {
			this.el.val(this.value);
		}

		return this.el;
	}
}

class FileWidget extends WidgetBase {
	getElement() {
		if (this.value) {
			this.el = $('<input type="text" readonly="readonly"></input>');
			this.el.val(this.value);
		}
		else {
			this.el = $('<input type="file"></input>');
		}

		return this.el;
	}

	publish() {
		var val = this.el.val();

		if (!val) {
			throw new Error();
		}

		val = val.split(/(\\|\/)/g).pop();

		this.el.after(
			$('<input type="text" readonly="readonly"></input>')
				.val(val)
		);

		this.el.hide();
	}

	setVal(val) {

	}

	val() {
		return this.el.val();
	}
}

class SelectWidget extends WidgetBase {
	getElement() {
		this.el = $('<select class="form-control custom-select"></select>');

		if (this.value) {
			this.el.val(this.value);
		}

		this.config.choices.forEach((choice) => {
			this.el.append(
				$('<option value="' + choice[0] + '">' + choice[1] + '</option>')
			);
		});

		return this.el;
	}
}


class List extends Backbone.View {
	get widgetMap() {
		return {
			'hidden': HiddenWidget,
			'text': TextWidget,
			'link': LinkWidget,
			'select': SelectWidget,
			'file': FileWidget,
		};
	}

	get events() {
		return {
			'click a.add': 'addItem',
			'click .remove-item': 'removeItem',
			'click .publish-item': 'publishItem',
		};
	}

	constructor(config) {
		super();

		this.values = [];

		this.config = config;

		this.render();

		this.setElement(this.element[0]);

		this.delegateEvents();

		if (this.config.values && this.config.values.length > 0) {
			try {
				(this.config.values).forEach((value) => {
					this.addItem(null, value);
				});
			}
			catch (e) { }
		}
		else {
			this.table.hide();
		}
	}

	render() {
		this.element = $('<div></div>', {'class': 'sma-widget-list'});

		if (this.config['cls']) {
			 this.element.addClass(this.config['cls']);
		}

		this.placeholder = $('<div></div>', {'class': 'placeholder'})
			.text(this.config['blankLabel'] || gettext('No items added.'))
			.appendTo(this.element)
			.append($('<a href="#" class="btn btn-default add">' + gettext('Add one') + '</a>.'));

		this.table = $('<table></table>').appendTo(this.element);

		var headers = $('<tr></tr>');

		this.config.items.forEach((item) => {
			if (item['type'] != 'hidden') {
				headers.append('<th>' + item.label + '</th>');
			}
		});

		headers.append('<th></th>');

		this.table.append(headers);

		this.tools = $('<div class="tools"></div>').appendTo(this.element);
		this.tools.hide();

		var addAnother = $('<a href="#" class="btn btn-default icon icon-add add">' + gettext('Add another') + '</a>')
			.appendTo(this.tools);
	}

	addItem(e, value=null) {
		if (e) {
			e.preventDefault();
		}

		this.placeholder.hide();
		this.table.show();
		this.tools.show();

		var row = $('<tr></tr>');
		var items = [];

		this.config.items.forEach((item, i) => {
			var cls = new this.widgetMap[item.type](item, value, i);
			var el = cls.getElement();
			var cell = $('<td></td>').append(el);

			row.append(cell);

			if (value) {
				cls.setVal(value[i]);
			}

			if (cls.hidden) {
				cell.hide();
			}

			items.push(cls);
		});

		var optscell = $('<td></td>').appendTo(row);

		var del = $('<a></a>', {
			'href': '#',
			'class': 'nc-icon-mini ui-1_trash-simple icon-remove remove-item'
		}).appendTo(optscell);

		if (this.config.needsPublish && value == null) {
			del.hide();
			$('<a></a>', {
				'href': '#',
				'class': 'icon icon-only icon-save publish-item'
			}).appendTo(optscell);
		}

		this.table.append(row);
		this.values.push(items);
	}

	removeItem(e) {
		if (!e) {
			return;
		}

		e.preventDefault();

		var row = $(e.currentTarget).parents('tr:first');
		var index = $('tr', this.table).index(row) - 1;

		var vals = this.values[index];

		this.values.splice(index, 1);

		row.remove();

		if ($('tr', this.table).length == 1) {
			this.placeholder.show();
			this.tools.hide();
			this.table.hide();
		}

		if (this.config.onDelete) {
			this.config.onDelete(vals);
		}
	}

	publishItem(e) {
		if (!e) {
			return;
		}

		var valid = true;

		e.preventDefault();

		var row = $(e.currentTarget).parents('tr:first');
		var index = $('tr', this.table).index(row) - 1;

		this.values[index].forEach((el) => {
			try {
				el.publish();
			} catch(e) {
				valid = false;
			}
		});

		if (valid) {
			$('.publish-item', row).hide();
			this.config.onPublish(this.values[index]);
		}
	}

	serialize() {
		var result = [];

		this.values.forEach((datarow) => {
			var data = [];

			datarow.forEach((item) => {
				data.push(item.val());
			});

			result.push(data);
		});

		return result;
	}
}

module.exports = List;
